import React, { PropsWithChildren, useEffect, useRef } from "react"
import anime from "animejs"
import classNames from "classnames"
import { usePresence } from "motion/react"

import styles from "./index.module.less"

const CONTAINER_ANIMATION = {
    enter: async (ele: HTMLElement) => {
        const bookLeft = ele.querySelector(`.${styles.bookLeft}`)
        const bookRight = ele.querySelector(`.${styles.bookRight}`)
        const label = ele.querySelector(`.${styles.label}`)
        const contentContainer = ele.querySelector(
            `.${styles.contentContainer}`
        )
        const enemyLabel = ele.querySelector(`.${styles.enemyLabel}`)
        const timeline = anime.timeline()
        ele.style.opacity = "1"
        ele.style.pointerEvents = "auto"
        const COMMON_IN = {
            duration: 500,
            opacity: [0, 1],
            translateZ: [0, 0],

            easing: "easeOutSine",
        }
        // const COMMON_OPACITY = {
        //     opacity: [0, 1],
        //     duration: 300,
        //     easing: "easeOutSine",
        // }
        // timeline.add({ targets: bookLeft, ...COMMON_OPACITY }, 0)
        timeline.add(
            {
                targets: bookLeft,
                ...COMMON_IN,
                translateY: ["20%", 0],
                translateX: ["10%", 0],
                rotate: ["-4deg", "-9deg"],
            },
            0
        )
        // timeline.add({ targets: bookRight, ...COMMON_OPACITY }, 100)
        timeline.add(
            {
                targets: bookRight,
                ...COMMON_IN,
                translateY: ["20%", 0],
                translateX: ["-10%", 0],
                rotate: ["-5deg", "0"],
            },
            100
        )
        // timeline.add({ targets: label, ...COMMON_OPACITY }, 100)
        timeline.add(
            { targets: label, ...COMMON_IN, translateY: ["20%", 0] },
            100
        )
        // timeline.add({ targets: contentContainer, ...COMMON_OPACITY }, 250)
        timeline.add(
            { targets: contentContainer, ...COMMON_IN, translateY: ["20%", 0] },
            250
        )
        timeline.add(
            {
                targets: enemyLabel,
                ...COMMON_IN,
                translateY: ["40%", 0],
                translateX: ["100%", 0],
                rotate: ["-31deg", "-31deg"],
            },
            400
        )
        return timeline.finished
    },
    exit: async (ele: HTMLElement) => {
        ele.style.pointerEvents = "none"
        return anime({
            targets: ele,
            opacity: [1, 0],
            duration: 600,
            easing: "easeInOutSine",
        }).finished
    },
}

const BookContainer: React.FC<
    PropsWithChildren<{
        className?: string
        style?: React.CSSProperties
        type?: "relic" | "enemy"
        active?: boolean
    }>
> = ({ className, style, children, type = "relic", active = false }) => {
    const [isPresent, safeToRemove] = usePresence()
    const containerRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        if (!containerRef.current) return
        if (isPresent) {
            CONTAINER_ANIMATION.enter(containerRef.current)
        } else {
            CONTAINER_ANIMATION.exit(containerRef.current).then(() => {
                safeToRemove()
            })
        }
    }, [isPresent])
    return (
        <div
            className={classNames(
                styles.bookContainer,
                styles[type],
                active && styles.active,
                className
            )}
            style={style}
            ref={containerRef}
        >
            <div className={styles.backgroundDeco}>
                <div className={styles.label}></div>
                <div className={styles.bookLeft}></div>
                <div className={styles.bookRight}></div>
            </div>
            <div className={styles.contentContainer}>{children}</div>
            {type === "enemy" && <div className={styles.enemyLabel}></div>}
        </div>
    )
}

export default BookContainer
